module.exports = __webpack_public_path__ + "static/media/awoolplanet_htu01.11e89aca.gif";